import * as fragment from "../fragments/cms";
import { resourceEditorFields } from "../fragments/editors";
import { examEditorItemFields } from "../fragments/exam";

export const getWebDocumentQuery = /* GraphQL */ `
  query GetWebDocument($input: ModelGetInput!) {
    getWebDocument(input: $input) {
      ${fragment.base}
      ${fragment.baseResource}
      content {
        body
      }
      resources {
        id
        sk
        resource {
          id
          sk
          name
          idInc
          isUnlisted
          visibility
          maturity
        }
      }
    }
  }
  `;

export const getPerformanceTaskQuery = /* GraphQL */ `
  query GetPerformanceTask($input: ModelGetInput!) {
    getPerformanceTask(input: $input) {
      ${fragment.base}
      ${fragment.baseResource}
      content {
        body
      }
      objectives {
        id
        sk
        objective {
          ${fragment.objective}
        }
      }
      resources {
        id
        sk
        resource {
          id
          sk
          name
          idInc
          maturity
        }
      }
      rubricIds {
        id
        sk
      }
      rubrics {
        id
        sk
        data
        rubric {
          id
          sk
          name
          workspaceId
          content {
            rubric
          }
        }
      }
    }
  }
  `;

export const getRubricQuery = /* GraphQL */ `
query GetRubric($input: ModelGetInput!) {
  getRubric(input: $input) {
    ${fragment.base}
    ${fragment.baseResource}
    content {
      rubric
    }
  }
}
`;

export const getResourceQuery = /* GraphQL */ `
  query GetResource($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      ${resourceEditorFields}
    }
  }
  `;

export const getExamEditorQuestion = /* GraphQL */ `
  query GetResource($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      ${examEditorItemFields}
    }
  }
  `;
